import { render, staticRenderFns } from "./UserGroupsList.vue?vue&type=template&id=478604a3&"
import script from "./UserGroupsList.vue?vue&type=script&lang=js&"
export * from "./UserGroupsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports